import { Component, Inject, OnInit, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';

export interface TermsDialogData {
    language?: string;
}

@Component({
    selector: 'app-terms-dialog',
    templateUrl: './terms-dialog.component.html',
    styleUrls: ['./terms-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        MatProgressSpinner,
        MatDialogActions,
        MatButton,
        TranslateModule,
    ],
})
export class TermsDialogComponent implements OnInit {
    tosText = signal('');
    currentLanguage: string;
    loading = signal(true);

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: TermsDialogData,
        public dialogRef: MatDialogRef<TermsDialogComponent>,
        private httpClient: HttpClient,
        private translateService: TranslateService
    ) {
        this.currentLanguage =
            data?.language || this.translateService.currentLang || 'de';
    }

    ngOnInit(): void {
        this.loadTermsOfService(this.currentLanguage);
    }

    async loadTermsOfService(lang: string): Promise<void> {
        try {
            this.loading.set(true);
            this.tosText.set(await lastValueFrom(
                this.httpClient.get(`assets/tos/${lang}.txt`, {
                    responseType: 'text',
                })
            ));
        } catch (error) {
            // Fallback to German if language file doesn't exist
            if (lang !== 'de') {
                this.tosText.set(await lastValueFrom(
                    this.httpClient.get('assets/tos/de.txt', {
                        responseType: 'text',
                    })
                ));
            } else {
                this.tosText.set('Error loading terms of service.');
            }
        } finally {
            this.loading.set(false);
        }
    }

    close(): void {
        this.dialogRef.close();
    }
}
